const safeEval = (fn, defaultValue) => {
  try {
    return fn();
  } catch (e) {
    return defaultValue;
  }
};

const safeFalsy = (val, fallback = '') => (val || val === 0 ? val : fallback);

const thousandSeparator = num => {
  const numParts = num.toString().split('.');
  numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return numParts.join('.');
};

const priceFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 4,
});

const formatPrice = p => {
  const formattedP = priceFormatter.format(p);
  return formattedP.replace(/\,/g, '');
};

const formInitialPriceHandler = p =>
  p ? formatPrice(safeFalsy(parseFloat(p))) : '';

const filterPreference = (preferences, category) => {
  const defaultPref = [
    {
      Category: 'Organization Setup',
      Push: true,
      Email: true,
    },
    {
      Category: 'Invitations',
      Push: true,
      Email: true,
    },
    {
      Category: 'Deal Status',
      Push: true,
      Email: false,
    },
    {
      Category: 'Transaction Status',
      Push: true,
      Email: false,
    },
  ];
  if (preferences) {
    return preferences.filter(pref => pref.Category === `${category}`)[0];
  }
  return defaultPref.filter(pref => pref.Category === `${category}`)[0];
};

const getDefaultAgent = (dealId, sections, dataStore) => {
  const currentSection = sections.filter(section => {
    const deals = section.deals.filter(d => d.DealId === dealId);
    return deals.length > 0;
  });

  if (currentSection.length === 0) return null;

  const availableVouchers = currentSection[0]?.vouchers.filter(
    v => v?.VoucherTypeDesc === 'Payable',
  );

  const availableTransactions = [];
  availableVouchers.map(v =>
    Array.from(v?.voucherTransactions).forEach(t => {
      const account = dataStore.getAccountFromId(t.AccountId);
      if (account.AccountTypeName === 'Expense') {
        t.ContactId = v?.ContactId;
        availableTransactions.push(t);
      }
    }),
  );

  if (availableTransactions.length > 0) {
    availableTransactions.sort((a, b) => b?.Price - a?.Price);

    return availableTransactions[0];
  }

  return null;
};

const isCompareObjects = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }

  let isSame = true;

  keys1.forEach(key => {
    if (object1[key] !== object2[key]) {
      isSame = false;
    }
  });

  return isSame;
};

module.exports = {
  safeEval,
  safeFalsy,
  thousandSeparator,
  priceFormatter,
  formatPrice,
  formInitialPriceHandler,
  filterPreference,
  getDefaultAgent,
  isCompareObjects,
};
